import { TFunction } from "i18next";
import { PAYMENT_STATUSES } from "../../types/payments";

/** Status filter options, built from the statuses the payments API can return. */
const statusItems = (t: TFunction) =>
  PAYMENT_STATUSES.map(status => ({
    label: t(`paymentStatus.${status}`),
    value: status
  }));

const dateRangeTitles = (t: TFunction) => [
  t("dateRange.startDate"),
  t("dateRange.endDate")
];

const filtersMobileInputs = (t: TFunction) => [
  {
    size: {
      xs: 12,
      sm: 6
    },
    id: "searchTxt",
    component: "textField",
    props: {
      label: t("chargesHistory.searchPatient"),
      showSearchIcon: true
    }
  },
  {
    size: {
      xs: 12,
      sm: 6
    },
    id: "status",
    component: "select",
    props: {
      label: t("chargesHistory.status"),
      items: statusItems(t)
    }
  },
  {
    id: "dates",
    size: {
      xs: 12,
      sm: 6
    },
    component: "dateRange",
    props: {
      titles: dateRangeTitles(t)
    }
  },
  {
    id: "prices",
    size: {
      xs: 12
    },
    component: "slider",
    props: {
      title: t("chargesHistory.priceRange"),
      min: 0,
      max: 3000,
      step: 10
    }
  }
];

const filtersDesktopInputs = (t: TFunction) => [
  {
    size: {
      sm: 12,
      md: 12,
      lg: 3,
      xl: 3
    },
    id: "searchTxt",
    component: "textField",
    props: {
      label: t("chargesHistory.searchPatient"),
      showSearchIcon: true
    }
  },
  {
    size: {
      sm: 4,
      md: 4,
      lg: 3
    },
    id: "status",
    component: "select",
    props: {
      label: t("chargesHistory.status"),
      items: statusItems(t)
    }
  },
  {
    id: "dates",
    size: {
      sm: 4,
      md: 4,
      lg: 3
    },
    component: "dateRange",
    props: {
      titles: dateRangeTitles(t)
    }
  },
  {
    id: "prices",
    size: {
      sm: 4,
      md: 4,
      lg: 3
    },
    component: "slider",
    props: {
      title: t("chargesHistory.priceRange"),
      min: 0,
      max: 3000,
      step: 10
    }
  }
];

const sortFields = (t: TFunction) => [
  { label: t("chargesHistory.paymentDate"), value: "paid_at" },
  { label: t("chargesHistory.requestDate"), value: "created_at" },
  { label: t("chargesHistory.status"), value: "status" }
];

const tableHeaders = (t: TFunction): any => [
  { label: "", size: "small" },
  {
    label: t("chargesHistory.requestDate")
  },
  {
    label: t("chargesHistory.paymentDate")
  },
  {
    label: t("chargesHistory.patientName"),
    align: "left"
  },
  {
    label: t("chargesHistory.status")
  },
  {
    label: t("chargesHistory.value")
  },
  {
    label: t("chargesHistory.receipt")
  }
];

export { sortFields, filtersMobileInputs, filtersDesktopInputs, tableHeaders };
